import React, { Component } from 'react'
import { Navigate, Route, Routes } from 'react-router'
import { PATH_LOGIN, PATH_CHANGE_PASSWORD, PATH_SET_PASSWORD, PATH_RESET_PASSWORD, PATH_REQUEST_PASSWORD_RESET, PATH_CLIENT_LIST } from 'routing/path'
import { adminRoutes } from 'routing/route.admin'
import { clientRoutes } from 'routing/route.client'
import { BaseLayout } from 'components/base-layout'
import SignIn from 'components/sign-in'
import ChangePassword from 'components/change-password'
import RequestPasswordReset from 'components/request-password-reset'
import ResetPassword from 'components/reset-password'
import Error404 from 'components/error404'

export default class AppRouter extends Component {
  render() {
    let { ...props } = this.props

    let routingList = clientRoutes.concat(adminRoutes);

    return (
      <Routes>
        <Route exact path="/" element={<Navigate replace to={PATH_CLIENT_LIST} />} />
        <Route exact path={PATH_LOGIN} element={<SignIn />} />
        <Route exact path={PATH_CHANGE_PASSWORD} element={<ChangePassword />} />
        <Route exact path={PATH_SET_PASSWORD + ":token"} element={<ResetPassword />} />
        <Route exact path={PATH_RESET_PASSWORD + ":token"} element={<ResetPassword />} />
        <Route exact path={PATH_REQUEST_PASSWORD_RESET} element={<RequestPasswordReset />} />
        {routingList.map((val, k) => {
          return <Route key={k} exact path={val.path} element={<BaseLayout component={val.component} {...props}/>} />
        })}
        <Route path="*" element={<Error404 />} />
      </Routes>
    )
  }
}
